import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentKey, AgentOption } from '../agentic-ecommerce.types';

@Component({
  selector: 'app-agentic-agent-selector',
  templateUrl: './agent-selector.component.html',
  styleUrls: ['./agent-selector.component.css'],
})
export class AgentSelectorComponent {
  @Input() agents: AgentOption[] = [];
  @Input() selectedAgentKey: AgentKey = '';

  @Output() agentSelected = new EventEmitter<AgentKey>();

  public selectAgent(agentKey: AgentKey): void {
    const agent = this.agents.find((option) => option.key === agentKey);

    if (!agent || agent.disabled) {
      return;
    }

    this.agentSelected.emit(agentKey);
  }

  public trackByAgent(index: number, agent: AgentOption): AgentKey {
    return agent.key || String(index);
  }
}
